// extracted by mini-css-extract-plugin
export default {"noteList":"NotesCellRenderer_noteList__WcPet"};